import { Popper as MuiPopper, styled } from "@mui/material";
import { timePickerName } from "../classes.js";
const Popper = styled(MuiPopper, {
  name: timePickerName,
  slot: "Popper",
  overridesResolver: (_props, styles) => styles.popper
})(({ theme }) => ({
  zIndex: theme.zIndex.modal
}));
export {
  Popper
};
//# sourceMappingURL=Popper.js.map
